<template>
  <div class="flex items-center gap-1">
    <component v-if="isComponent" :is="label" v-bind="props" />
    <template v-else>{{ label }}</template>
    <a-tooltip v-if="infoIcon && tooltip" :title="tooltip" placement="top">
      <img :src="imagePath.infoIcon" alt="info" class="info-icon" />
    </a-tooltip>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import imagePath from '@/javascript/imagePath';

const props = defineProps({
  label: {
    type: [String, Object],
    required: true,
  },
  infoIcon: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    default: '',
  },
});

const isComponent = computed(() => {
  return typeof props.label === 'object';
});
</script>

<style scoped>
.info-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>
